import React, { useEffect, useState } from "react";
import { getTours } from "@/api";
import { fmtMxn } from "./adminShared";
import { CATEGORIES } from "@/config";

export default function AdminTours() {
  const [tours, setTours] = useState([]);
  useEffect(() => {
    getTours().then(setTours).catch(() => {});
  }, []);

  const catLabel = (key) => CATEGORIES.find((c) => c.key === key)?.es || key;

  return (
    <div data-testid="admin-tours">
      <p className="eyebrow mb-2">Catálogo</p>
      <h1 className="font-serif-hc font-light text-3xl md:text-4xl text-[#F5F2EA]">Tours</h1>
      <p className="text-sm text-[#A3A095] mt-2">Catálogo publicado en el sitio. La edición desde el panel llegará próximamente.</p>

      <div className="mt-7 overflow-x-auto border border-[#1E2B25]">
        <table className="w-full text-sm min-w-[720px]">
          <thead>
            <tr className="bg-[#0C1310] text-left">
              {["Tour", "Categoría", "Duración", "Precio", "Etiqueta", "Horarios"].map((h) => (
                <th key={h} className="p-4 eyebrow font-normal">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {tours.map((t) => (
              <tr key={t.id} data-testid={`tour-row-${t.slug}`} className="border-t border-[#1E2B25]">
                <td className="p-4">
                  <p className="text-[#F5F2EA]">{t.name?.es}</p>
                  <p className="text-xs text-[#A3A095] mt-0.5">{t.location?.es}</p>
                </td>
                <td className="p-4 text-[#A3A095]">{catLabel(t.category)}</td>
                <td className="p-4 text-[#F5F2EA]">{t.duration?.es}</td>
                <td className="p-4 text-[#C4A661]">{t.price_mxn > 0 ? fmtMxn(t.price_mxn) : "A consultar"}</td>
                <td className="p-4 text-[#A3A095]">{t.label?.es || "—"}</td>
                <td className="p-4 text-[#A3A095]">{t.schedules?.length ? t.schedules.join(", ") : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
